import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService } from 'cbc-shared-lib';

import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

import {
  Sgkd048aService,
  Sgkd048aRequest,
  Sgkd048aResponse
} from 'sg-api';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd002dSgkd048aService {

  private _rsesult$ = new Subject<Sgkd048aResponse>();

  constructor(
    private sgkd048aService: Sgkd048aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 支払方法変更可否チェックAPI呼び出し
   * @param recptFixNo 請求お客さま番号
   * @param businessDate 業務日付
   * @memberof UsedSgkd002dSgkd048aService
   */
  select(recptFixNo: string, businessDate: string): Observable<Sgkd048aResponse> {

    // リクエスト生成
    let request: Sgkd048aRequest = {
      requestCommon: {},
      requestDto: {
        recptFixNo: recptFixNo
      }
    };
    request.requestCommon.businessDate = businessDate;

    return this.sgkd048aService.doSGKD048APost(this.apiCommonService.setRequestCommon(request), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._rsesult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD048A');
          return throwError(err.message);
        }
      )
    );
  }
}
